import * as React from "react";

import type { DesignaliProps } from "../../types";

export const Logs = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M13 12h8" />
        <path d="M13 18h8" />
        <path d="M13 6h8" />
        <path d="M3 12h1" />
        <path d="M3 18h1" />
        <path d="M3 6h1" />
        <path d="M8 12h1" />
        <path d="M8 18h1" />
        <path d="M8 6h1" />
      </svg>
    );
  },
);

export default Logs;
